import React, { useState } from 'react';
import Filter from '../../../components/filter/filter';
import { api } from '../../../components/api/api';
import { eTipoDownload } from '../../../enum/eTipoDownload';
import { useGestaoMotoristaVendedor } from './hook/useGestaoMotoristaVendedor';
import ButtonTooltip from '../../../components/Inputs/ButtonTooltip';
import { format } from 'date-fns';
import { FaCheckCircle, FaFileSignature } from 'react-icons/fa';
import ModalEditarStatusPedido from '../../../components/Modals/Pedido/ModalEditarStatusPedido';
import ModalAssinaturaPedido from '../../../components/Modals/Pedido/ModalAssinaturaPedido';
import TabelaCarregando from '../../../components/ui/TabelaCarregando';

function GestaoMotoristaVendedor() {

    const {
        pedidos,
        sortedPedidos,
        pedidosFiltro,
        statusPagamento,
        statusPedido,
        dtInicio,
        dtFim,
        produtos,
        nome,
        nPedido,
        vendedores,
        vendedorSelecionado,
        statusPagamentos,
        statusPagamentosSelecionado,
        statusPedidoSelecionado,
        onChangeFiltroStatusPedido,
        BuscarTodosPedidos,
        setDtInicio,
        setDtFim,
        setNome,
        setNPedido,
        setVendedorSelecionado,
        setStatusPagamentos,
        setStatusPagamentosSelecionado,
        handleSort,
        getSortIcon,
        showEditarStatusModal,
        pedidoSelecionado,
        handleEditarStatusPedido,
        handleHideEditarStatusModal,
        handleShowEditarStatusModal,
        showAssinaturaModal,
        pedidoAssinaturaSelecionado,
        handleShowAssinaturaModal,
        handleHideAssinaturaModal,
        carregando
    } = useGestaoMotoristaVendedor();

    const getStatusButtonProps = (statusPedidoId) => {
        switch (statusPedidoId) {
            case 1:
                return { text: "Aberto", color: "btn btn-info", icon: <FaCheckCircle /> };
            case 2:
                return { text: "Separação", color: "btn btn-success", icon: <FaCheckCircle /> }
            case 3:
                return { text: "Despachado", color: "btn btn-warning", icon: <FaCheckCircle /> };
            case 4:
                return { text: "Concluído", color: "btn btn-success", icon: <FaCheckCircle /> };
            case 5:
                return { text: "Cancelado", color: "btn btn-danger", icon: <FaCheckCircle /> };
            default:
                return { text: "Desconhecido", color: "btn btn-secondary", icon: <FaCheckCircle /> };
        }
    };

    return (
        <div className="content">
            {showAssinaturaModal && (
                <ModalAssinaturaPedido
                    pedido={pedidoAssinaturaSelecionado}
                    onHide={handleHideAssinaturaModal}
                    onReload={BuscarTodosPedidos}
                />
            )}

            {showEditarStatusModal && (
                <ModalEditarStatusPedido
                    pedido={pedidoSelecionado}
                    statusPedido={statusPedido}
                    onHide={handleHideEditarStatusModal}
                    onEdit={handleEditarStatusPedido}
                    onReload={BuscarTodosPedidos}
                    apenasEntregue
                />
            )}

            <Filter
                fetchClientes={BuscarTodosPedidos}
                setDataInicio={setDtInicio}
                setDataFim={setDtFim}
                dataInicio={dtInicio}
                dataFim={dtFim}
                showNovoCliente={false}
                showFiltroNome={true}
                filtroNome={nome}
                filtroStatusPedido={true}
                statusPedido={statusPedido}
                onChangeFiltroStatusPedido={onChangeFiltroStatusPedido}
                handleInputChange={e => { setNome(e.target.value); BuscarTodosPedidos() }}
                extrairDados={true}
                tipoDownload={eTipoDownload.GestaoPedidos}
                nPedido={nPedido}
                setNPedido={setNPedido}
                showNPedido={true}
                vededores={vendedores}
                filtroVendedor={vendedores.length > 0}
                setVendedorSelecionado={setVendedorSelecionado}
                vendedorSelecionado={vendedorSelecionado}
                statusPagamentos={statusPagamentos}
                setStatusPagamentos={setStatusPagamentos}
                statusPagamentosSelecionado={statusPagamentosSelecionado}
                setStatusPagamentosSelecionado={setStatusPagamentosSelecionado}
                filtroStatusPagamento={true}
                statusPedidoSelecionado={statusPedidoSelecionado}
            />

            <div className="tabela-responsiva">
            <table className="table table-striped">
                <thead>
                    <tr>
                        <th style={{ cursor: 'pointer' }} onClick={() => handleSort('pedido_id')}>N° Pedido {getSortIcon('pedido_id')}</th>
                        <th style={{ cursor: 'pointer' }} onClick={() => handleSort('nomeCliente')}>Nome Cliente {getSortIcon('nomeCliente')}</th>
                        <th style={{ cursor: 'pointer' }} onClick={() => handleSort('nomeVendedor')}>Nome Vendedor {getSortIcon('nomeVendedor')}</th>
                        <th style={{ cursor: 'pointer' }} onClick={() => handleSort('localidade')}>Localidade {getSortIcon('localidade')}</th>
                        <th style={{ cursor: 'pointer' }} onClick={() => handleSort('data_pedido')}>Data Do Pedido {getSortIcon('data_pedido')}</th>
                        <th style={{ cursor: 'pointer' }} onClick={() => handleSort('valor_total')}>Valor Total Pedidos (R$) {getSortIcon('valor_total')}</th>
                        <th style={{ cursor: 'pointer' }} onClick={() => handleSort('saldo_devedor')}>Saldo Devedor (R$) {getSortIcon('saldo_devedor')}</th>
                        <th>Status Pedido</th>
                        <th>Status Pagamento</th>
                        <th className="coluna-acoes">Ações</th>
                    </tr>
                </thead>
                <tbody>
                    {sortedPedidos.map((produto, index) => (
                        <tr key={produto.pedido_id}>
                            <td data-label="N° Pedido">{produto.pedido_id}</td>
                            <td data-label="Nome Cliente">{produto.nomeCliente}</td>
                            <td data-label="Nome Vendedor">{produto.nomeVendedor}</td>
                            <td data-label="Localidade">{produto.localidade}</td>
                            <td data-label="Data Do Pedido">{format(produto.data_pedido, "dd/MM/yyyy")}</td>
                            <td data-label="Valor Total Pedido (R$)">R$ {produto.valor_total.toFixed(2).replaceAll('.', ',')}</td>
                            <td data-label="Saldo Devedor (R$)">R$ {produto.saldo_devedor.toFixed(2).replaceAll('.', ',')}</td>
                            <td data-label="Status Pedido">{statusPedido.filter(x => x.status_pedido_id === produto.status_pedido_id)[0]?.nome}</td>
                            <td data-label="Status Pagamento">{statusPagamento.filter(x => x.status_pagamento_id === produto.status_pagamento_id)[0]?.nome}</td>
                            <td data-label="Ações" className="coluna-acoes">
                                <div className="acoes-tabela">
                                    {produto.status_pedido_id !== 6 && produto.status_pedido_id !== 4 && (
                                        <ButtonTooltip
                                            text={"Entregar Pedido"}
                                            textButton={<FaCheckCircle />}
                                            className={`btn btn-success`}
                                            top={true}
                                            onClick={() => handleShowAssinaturaModal(produto)}
                                        />
                                    )}
                                </div>
                            </td>
                        </tr>
                    ))}
                    {carregando && <TabelaCarregando colunas={10} texto="Carregando pedidos..." />}
                    {!carregando && pedidos.length === 0 && <tr>
                        <td colSpan="10" className="tabela-vazia"><span>Não foi encontrado nenhum pedido...</span></td>
                    </tr>}
                </tbody>
            </table>
            </div>
        </div>
    );
}

export default GestaoMotoristaVendedor;